import { VerificationMethod } from '@dss-libs/shared/type/common-types';

export const VerificationMethodTranslationMapper = new Map([
  // [VerificationMethod.Whatsapp, 'VERIFICATION_METHOD.WHATSAPP'],
  [VerificationMethod.Email, 'VERIFICATION_METHOD.EMAIL'],
  // [VerificationMethod.WhatsappAndEmail, 'VERIFICATION_METHOD.WHATSAPP_AND_EMAIL'],
]);
